import * as AccountStore from '../../store/AccountStore';
import * as GuideStore from '../../store/GuideStore';
import * as React from 'react';
import MediaQuery from 'react-responsive'
import { AvailableEquipment, PersonalAccountService } from '../../models/AccountModels';
import { ClientProcessingService, ProcessingServiceStatusEnum } from '../../models/ServiceModels';
import { Modal, Popup } from '../components/Modals';

import { ApiUrls } from '../../constants/apiUrls';
import { AppealRequests } from '../../apiRequests/AppealRequests';
import { ApplicationState } from '../../store';
import CloseIcon from '../../images/dynamicIcons/closeIcon';
import DataString from '../components/DataString';
import Input from '../components/Input';
import Navigation from '../../constants/enums/NavigationEnum';
import { RouteComponentProps } from 'react-router';
import { ServicesRequests } from '../../apiRequests/ServicesRequests';
import { Settings } from '../../constants/settings';
import { ShortAppealData } from '../../models/AppealReferanceModels';
import { Slider } from '../components/Slider';
import { Spinner } from '../components/Loader';
import { connect } from 'react-redux';
import detailsIcon from '../../images/detailsIcon.svg';
import disatvantageIcon from '../../images/disatvantageIcon.svg';
import moment from 'moment';
import offerCustomIcon from '../../images/offerCustomIcon.svg';
import offerMonitorImage from '../../images/offerMonitorImage.png';
import offerPersonIcon from '../../images/offerPersonIcon.svg';
import offerSetupIcon from '../../images/offerSetupIcon.svg';
import offerTubeImage from '../../images/offerTubeImage.png';
import { orderBy } from 'lodash';
import sliderNextIcon from '../../images/sliderNextIcon.svg';
import sliderPreviousIcon from '../../images/sliderPreviousIcon.svg';
import testTube from '../../images/testTube.png';
import appstoreIcon from '../../images/appstoreIcon.svg'
import BannerPro1920 from '../../images/BannerPro1920.png'; 
import BannerPro1440 from '../../images/BannerPro1440.png'; 
import BannerPro1280 from '../../images/BannerPro1280.png'; 
import BannerPro1024 from '../../images/BannerPro1024.png'; 
import BannerPro960 from '../../images/BannerPro960.png'; 
import BannerPro768 from '../../images/BannerPro768.png'; 
import BannerPro640 from '../../images/BannerPro640.png'; 
import BannerPro480 from '../../images/BannerPro480.png'; 
import BannerPro320 from '../../images/BannerPro320.png'; 






const testTubes = [testTube, testTube, testTube, testTube, testTube, testTube, testTube, testTube];

type GeneralPageProps =
    AccountStore.AccountStateState &
    GuideStore.GuideState &
    typeof AccountStore.actionCreators &
    RouteComponentProps<{}>;

interface GeneralPageState {
    selectedScore: number,
    sliderShow: boolean,
    renewalCancelIsOpen: boolean,
    renewalReasonCancelIsOpen: boolean,
    renewalReasonCancelComment: string,
    renewalReasonCancelIndex: number,
    renewalCancelProcessed: boolean,
    renewalCancelSuccess: boolean,
    renewalCancelError: boolean,
    cancelledSubDateEnd: Date | null,
    offerIsOpen: boolean,
    appAccountIsOpen: boolean,
    selectedSlide: number,
    mobileSliderHorizontalOffset: number,
    swipeStarted: boolean,
    swipeStartLeft: number,
    swipeCurrentLeft: number,
    swipeCurrentOffset: number,
    swipeLastOffset: number,
    equipmentSliderIndex: number,
    withoutTransition: boolean,
    timerStarted: boolean
}

class GeneralPage extends React.PureComponent<GeneralPageProps, GeneralPageState> {

    constructor(props: GeneralPageProps) {
        super(props);

        this.state = {
            selectedScore: -1,
            sliderShow: false,
            renewalCancelIsOpen: false,
            renewalReasonCancelIsOpen: false,
            renewalReasonCancelComment: "",
            renewalReasonCancelIndex: -1,
            renewalCancelProcessed: false,
            renewalCancelSuccess: false,
            renewalCancelError: false,
            cancelledSubDateEnd: null,
            offerIsOpen: false,
            appAccountIsOpen: false,
            selectedSlide: 0,
            withoutTransition: false,
            mobileSliderHorizontalOffset: 0,
            swipeStarted: false,
            swipeStartLeft: 0,
            swipeCurrentLeft: 0,
            swipeCurrentOffset: 0,
            swipeLastOffset: 0,
            equipmentSliderIndex: 0,
            timerStarted: false
        }
    }

    private apiAppealRequest = new AppealRequests();
    private apiServiceRequest = new ServicesRequests();

    async componentDidMount() {

        var scroller = document.getElementById("accounts_items");
        this.setState({ sliderShow: (scroller?.scrollWidth as number) > (scroller?.clientWidth as number + 110) })
    }



    async componentWillUnmount() {
        await this.props.UnMountAccountStateAction();

    }


    private GetSubscriptionStatusCard(service: ClientProcessingService) {

        switch (service.status) {
            case ProcessingServiceStatusEnum.CreateTaskTag:
                return <>
                    <DataString valueColor="#7d0a99" title="Статус" value="Создание заявки" />
                    <div className='name-passive--8'>Заявка находится в процессе создания. Оплата подписки станет доступна через некоторое время</div>
                </>
            case ProcessingServiceStatusEnum.TransferInvoice:
                return <>
                    <DataString valueColor="#7d0a99" title="Статус" value="Создание счета" />
                    <div className='name-passive--8'>Идет формирование счета. Оплата подписки станет доступна через некоторое время</div>
                </>
            case ProcessingServiceStatusEnum.WaitingPayment:
                return <>
                    <DataString valueColor="#7d0a99" title="Статус" value="Ожидание оплаты" />
                    <div className='name-passive--8'>Оплата подписки доступна. Перейдите по ссылке ниже для оплаты</div>
                    <a className='general__panel_card_sub-payment-button  button button-text mini press-bottom' target='_blank' href={
                        `${service.option?.redirectUrl || `${Settings.PayCyfralServiceSite}Orders/${this.props.accounts[this.props.selectedAccount].processingServices[0].option?.redirectUrl}`}`
                    }>
                        Перейти к оплате
                    </a>
                    {/*<a className='general__panel_card_sub-payment-button  button button-text mini press-bottom' target='_blank' href={
                        service.option !== null && service.option?.payOrderUrl !== null ? service.option?.payOrderUrl :
                            `${Settings.PayCyfralServiceSite}Orders/${this.props.accounts[this.props.selectedAccount].balance.personalAccount}`
                    }>
                        Перейти к оплате
                    </a>*/}
                </>
            case ProcessingServiceStatusEnum.Activation:
                return <>
                    <DataString valueColor="#7d0a99" title="Статус" value="Активация" />
                    <div className='name-passive--8'>Оплата прошла успешно. Услуга станет доступной в течение нескольких минут</div>
                    <a target='_blank' href='https://erth.page.link/o5ma' className='button-text blue button general__panel_card_subscribe_active press-bottom'>
                        Перейти в приложение
                    </a>
                </>
            case ProcessingServiceStatusEnum.Complete:
            default: return <></>

                return <>
                    <DataString title="Статус" value="Активация" />
                    <DataString title="Статус" value="Активация" />
                    <DataString title="Статус" value="Активация" />

                    <a target='_blank' href='https://erth.page.link/o5ma' className='button-text blue button general__panel_card_subscribe_active'>
                        Отменить подписку
                    </a>
                </>

        }
    }

    private async RenewalCancel() {
        var account = this.props.accounts[this.props.selectedAccount]
        var subscription = account.services.filter(e => e.isRenewal === true)[0];
        this.setState({ renewalCancelProcessed: true, cancelledSubDateEnd: subscription.dateEnd })

        let response = await this.apiServiceRequest.CancelSubscriptionRenewal(account.balance.personalAccountId, this.state.renewalReasonCancelComment)

        if (response.result) {
            await this.props.GetAccountsStateAction();
            this.setState({ renewalCancelProcessed: false, renewalReasonCancelIsOpen: false, renewalCancelSuccess: true })
        }
        else {
            this.setState({ renewalCancelProcessed: false, renewalReasonCancelIsOpen: false, renewalCancelError: true })
        }
    }




    public render() {

        var account = this.props.accounts[this.props.selectedAccount]
        var activeAppeals: ShortAppealData[] = [];
        var doneAppeals: ShortAppealData[] = [];
        var subscription: PersonalAccountService | undefined = undefined;
        var availableEquipment: AvailableEquipment[] = [];


        var subDisabled = this.state.renewalReasonCancelComment === "" && this.state.renewalReasonCancelIndex === -1;


        try {

            activeAppeals = orderBy(account.appeals.filter(e => e.taskTagStatusName === "Активна"), e => e.dateCreate, "desc");
            doneAppeals = orderBy(account.appeals.filter(e => e.taskTagStatusName === "Завершена"), e => e.dateCreate, "desc");
            subscription = account.services.filter(e => e.isRenewal === true && e.serviceName === "ПМВС" && !(account.processingServices?.length > 0))[0];

        }
        catch {

        }
        try {
            let availableEquipmentIndex = this.props.accountsAvailableEquipments.findIndex(e => e.personalAccountId === account?.balance?.personalAccountId);

            if (availableEquipmentIndex !== -1)
                if (this.props.accountsAvailableEquipments[availableEquipmentIndex].availableEquipment !== null)
                    availableEquipment = this.props.accountsAvailableEquipments[availableEquipmentIndex].availableEquipment

        }
        catch { }


        return (

            <>

                {this.state.renewalCancelProcessed && <div className='blocker' onClick={(e) => e.stopPropagation()} />}

                {/*<Modal isOpen={this.state.appAccountIsOpen} onClose={() => this.setState({ appAccountIsOpen: false })}>
                    <div className='general_offer-small-modal'>

                        <div className='general__r-cancel_close button' onClick={() => this.setState({ appAccountIsOpen: false })}>
                            <CloseIcon />
                        </div>
                        <div className='modal-header-large'>Мои учетные данные для входа</div>

                        <DataString title='Логин' value={account?.accessMobileAppDomRu?.login} />
                        <DataString title='Пароль' value={account?.accessMobileAppDomRu?.password} />




                    </div>

                </Modal>
*/}
                <Modal isOpen={this.state.renewalCancelIsOpen} onClose={() => this.setState({ renewalCancelIsOpen: false })}>
                    <div className='general__r-cancel'>
                        <div className='general__r-cancel_close button' onClick={() => this.setState({ renewalCancelIsOpen: false })}>
                            <CloseIcon />
                        </div>
                        <div className='modal-header-large general__r-cancel_text'>Что вас ждет после отключения подписки</div>
                        <div className='name-passive--8 general__r-cancel_text'>Вы перейдете на базовый тариф и следующие функции станут недоступны:</div>
                        <div className='general__r-cancel_disadvantages'>
                            <div className='general__r-cancel_disadvantages_item'>
                                <img src={disatvantageIcon} />
                                <div className='name-passive--10'>Просмотр и скачивание видео</div>
                            </div>
                            <div className='devider--horizontal' />
                            <div className='general__r-cancel_disadvantages_item'>
                                <img src={disatvantageIcon} />
                                <div className='name-passive--10'>Видеозвонки</div>
                            </div>
                            <div className='devider--horizontal' />
                            <div className='general__r-cancel_disadvantages_item'>
                                <img src={disatvantageIcon} />
                                <div className='name-passive--10'>Метки движения</div>
                            </div>
                        </div>
                        <div className='general__r-cancel_buttons'>
                            <div className='button button-text' onClick={() => this.setState({ renewalCancelIsOpen: false })}>Не отключать</div>
                            <div className='button button-text blue' onClick={() => this.setState({ renewalReasonCancelIsOpen: true, renewalCancelIsOpen: false })}>Все равно отключить</div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={this.state.renewalReasonCancelIsOpen} onClose={() => this.setState({ renewalReasonCancelIsOpen: false })}>
                    <div className='general__r-cancel'>
                        <div className='general__r-cancel_close button' onClick={() => this.setState({ renewalReasonCancelIsOpen: false })}>
                            <CloseIcon />
                        </div>
                        <div className='modal-header-large general__r-cancel_text'>Почему вы хотите отменить подписку?</div>
                        <div className='general__r-cancel_disadvantages'>
                            <div className={`name-passive--10 button ${this.state.renewalReasonCancelIndex == 0 && "selected"}`}
                                onClick={() => this.setState({ renewalReasonCancelIndex: this.state.renewalReasonCancelIndex === 0 ? -1 : 0, renewalReasonCancelComment: this.state.renewalReasonCancelIndex === 0 ? "" : "Хочу приостановить подписку, возобновлю позже" })}>Хочу приостановить подписку, возобновлю позже</div>
                            <div className='devider--horizontal' />
                            <div className={`name-passive--10 button ${this.state.renewalReasonCancelIndex == 1 && "selected"}`}
                                onClick={() => this.setState({ renewalReasonCancelIndex: this.state.renewalReasonCancelIndex === 1 ? -1 : 1, renewalReasonCancelComment: this.state.renewalReasonCancelIndex === 1 ? "" : "Больше не пользуюсь приложением «Умный Дом.ru»" })}>Больше не пользуюсь приложением «Умный Дом.ru»</div>
                            <div className='devider--horizontal' />
                            <div className={`name-passive--10 button ${this.state.renewalReasonCancelIndex == 2 && "selected"}`}
                                onClick={() => this.setState({ renewalReasonCancelIndex: this.state.renewalReasonCancelIndex === 2 ? -1 : 2, renewalReasonCancelComment: this.state.renewalReasonCancelIndex === 2 ? "" : "Мне не хватает функций в подписке" })}>Мне не хватает функций в подписке</div>
                            <div className='devider--horizontal' />
                            <div className={`name-passive--10 button ${this.state.renewalReasonCancelIndex == 3 && "selected"}`}
                                onClick={() => this.setState({ renewalReasonCancelIndex: this.state.renewalReasonCancelIndex === 3 ? -1 : 3, renewalReasonCancelComment: this.state.renewalReasonCancelIndex === 3 ? "" : "Подписка стоит дорого" })}>Подписка стоит дорого</div>
                            <div className='devider--horizontal' />
                            <Input type={"text"} placeholder='Своя причина...' className='general__r-cancel_disadvantages_input' onChange={(e) => this.setState({ renewalReasonCancelComment: e })} />

                        </div>
                        <div className='general__r-cancel_buttons'>
                            {!this.state.renewalCancelProcessed ?
                                <>
                                    <div className={`button button-text `} onClick={() => this.setState({ renewalReasonCancelIsOpen: false, renewalReasonCancelComment: "", renewalReasonCancelIndex: -1 })}>Не отключать</div>
                                    <div className={`button button-text blue ${subDisabled && "disabled"}`}
                                        onClick={() => !subDisabled && this.RenewalCancel()}>
                                        Все равно отключить</div>
                                </>
                                : <Spinner secondColor='blue' />}
                        </div>

                    </div>
                </Modal>
                {availableEquipment.length !== 0 &&
                    <Modal isOpen={this.state.offerIsOpen} onClose={() => this.setState({ offerIsOpen: false })} id="offer-modal">
                        <div className='general_offer-modal'>
                            <div className='general_offer-modal_close button' onClick={() => this.setState({ offerIsOpen: false })}>
                                <CloseIcon />
                            </div>
                            <div className='general_offer-modal_slider'>

                                {availableEquipment.map((element, index) =>
                                    <div key={index} className={`general_offer-modal_slider_item 
                                                ${this.state.equipmentSliderIndex > index && 'previous'}
                                                ${this.state.equipmentSliderIndex < index && 'next'}`}>
                                        <div className='general_offer-modal_slider_item_header'>
                                            <img src={sliderPreviousIcon} className='general_offer-modal_slider_button button'
                                                onClick={() => this.setState({
                                                    selectedSlide: 0,
                                                    equipmentSliderIndex: this.state.equipmentSliderIndex === 0 ? availableEquipment.length - 1 : this.state.equipmentSliderIndex - 1
                                                })} />
                                            <div className='modal-header-large '>{element?.equipmentFullName}</div>
                                            <img src={sliderNextIcon} className='general_offer-modal_slider_button right button'
                                                onClick={() => this.setState({
                                                    selectedSlide: 0,
                                                    equipmentSliderIndex: this.state.equipmentSliderIndex === availableEquipment.length - 1 ? 0 : this.state.equipmentSliderIndex + 1
                                                })}
                                            />
                                        </div>

                                        <div className='general_offer-modal_main'>
                                            <div className={`general_offer-modal_main_slider ${this.state.withoutTransition && "withoutTransition"}`}>
                                                <div className='general_offer-modal_main_slider_viewer' >
                                                    <img src={`${ApiUrls.GetEquipmentImage}/${element.images[element.images.length - 1].imageId}`}
                                                        className={`general_offer-modal_main_slider_viewer_item 
                                                                        ${this.state.selectedSlide > -1 && "slided"}
                                                                        ${this.state.selectedSlide === -1 && "selected"}`}
                                                        key={-1}></img>
                                                    {element?.images.map((e, i) => {
                                                        return <img src={`${ApiUrls.GetEquipmentImage}/${e.imageId}`}
                                                            className={`general_offer-modal_main_slider_viewer_item 
                                                                        ${this.state.selectedSlide > i && "slided"}
                                                                        ${this.state.selectedSlide === i && "selected"}`}
                                                            key={i}></img>
                                                    })}
                                                    <img src={`${ApiUrls.GetEquipmentImage}/${element.images[0].imageId}`}
                                                        className={`general_offer-modal_main_slider_viewer_item 
                                                                        ${this.state.selectedSlide > element.images.length && "slided"}
                                                                        ${this.state.selectedSlide === element.images.length && "selected"}`}
                                                        key={-2}></img>
                                                </div>
                                                <div className='general_offer-modal_main_slider_slider'>
                                                    <div className='general_offer-modal_main_slider_slider_button button'
                                                        onClick={() => !this.state.timerStarted && this.setState({
                                                            selectedSlide: this.state.selectedSlide - 1,
                                                            withoutTransition: false,
                                                            timerStarted: this.state.selectedSlide - 1 < 0
                                                        }, () => { this.state.selectedSlide < 0 && setTimeout(() => this.setState({ selectedSlide: element.images.length - 1, withoutTransition: true, timerStarted: false }), 300) })}><img src={sliderPreviousIcon}></img></div>
                                                    <div className='general_offer-modal_main_slider_slider_wrapper'>

                                                        {element.images.length >= 2 &&
                                                            <img src={`${ApiUrls.GetEquipmentImage}/${element.images[element.images.length - 2].imageId}`} className={`general_offer-modal_main_slider_item 
                                                                            ${this.state.selectedSlide > -1 && "prev"}
                                                                            ${this.state.selectedSlide === -1 && "prev-show"}
`}
                                                                key={-2}></img>}
                                                        {element.images.length >= 1 &&
                                                            <img src={`${ApiUrls.GetEquipmentImage}/${element.images[element.images.length - 1].imageId}`} className={`general_offer-modal_main_slider_item 
                                                                            ${this.state.selectedSlide > 0 && "prev"}
                                                                            ${this.state.selectedSlide === 0 && "prev-show"}
`}
                                                                key={-1}
                                                                onClick={() => this.setState({ selectedSlide: -1, timerStarted: true }, () => setTimeout(() => this.setState({ withoutTransition: true, selectedSlide: element.images.length - 1, timerStarted: false }), 300))}></img>}
                                                        {element?.images.map((e, i) => {
                                                            return <img src={`${ApiUrls.GetEquipmentImage}/${e.imageId}`} className={`general_offer-modal_main_slider_item 
                                                                            ${this.state.selectedSlide > i + 1 && "prev"}
                                                                            ${this.state.selectedSlide === i + 1 && "prev-show"}
                                                                            ${this.state.selectedSlide === i - 1 && "next-show"}
                                                                            ${this.state.selectedSlide < i - 1 && "next"}`}
                                                                key={i}
                                                                onClick={() => this.setState({ selectedSlide: i, withoutTransition: false })}></img>
                                                        })}
                                                        {element.images.length >= 1 &&
                                                            <img src={`${ApiUrls.GetEquipmentImage}/${element.images[0].imageId}`}
                                                                className={`general_offer-modal_main_slider_item 
                                                                            ${this.state.selectedSlide === element.images.length - 1 && "next-show"}
                                                                            ${this.state.selectedSlide < element.images.length - 1 && "next"}`}
                                                                key={-3}
                                                                onClick={() => this.setState({ selectedSlide: element.images.length, timerStarted: true }, () => setTimeout(() => this.setState({ withoutTransition: true, selectedSlide: 0, timerStarted: false }), 300))}></img>}
                                                        {element.images.length >= 2 &&
                                                            <img src={`${ApiUrls.GetEquipmentImage}/${element.images[1].imageId}`} className={`general_offer-modal_main_slider_item 
                                                                            ${this.state.selectedSlide === element.images.length && "next-show"}
                                                                            ${this.state.selectedSlide < element.images.length && "next"}`}

                                                                key={-4}></img>}
                                                    </div>
                                                    <div className='general_offer-modal_main_slider_slider_button button'
                                                        onClick={() => !this.state.timerStarted && this.setState({
                                                            selectedSlide: this.state.selectedSlide + 1,
                                                            withoutTransition: false,
                                                            timerStarted: this.state.selectedSlide + 1 >= availableEquipment[this.state.equipmentSliderIndex].images.length
                                                        }, () => { this.state.selectedSlide >= availableEquipment[this.state.equipmentSliderIndex].images.length && setTimeout(() => this.setState({ selectedSlide: 0, withoutTransition: true, timerStarted: false }), 300) })}><img src={sliderNextIcon}></img></div>




                                                </div>
                                            </div>

                                            <Slider width={290} height={260} gap={12} parentId='offer-modal' paginationOn={true} showInDesctop={false} showInMobile={true}>
                                                {element?.images.map((e, i) => {
                                                    return <img key={i} src={`${ApiUrls.GetEquipmentImage}/${e.imageId}`} className='general_offer-modal_main_slider--mobile_item ' ></img>
                                                })}
                                            </Slider>
                                            <div className='general_offer-modal_main_info-wrapper'>

                                                <div className='general_offer-modal_main_info_info'>
                                                    {orderBy(element?.specifications, (e) => e.orderNumber).map((e, i) =>
                                                        <React.Fragment key={i}>
                                                            <div key={i} className={`name-passive--8 `}>{e.nameSpecification}</div>
                                                            <div key={(i + 1) * 1000} className={`value-text--normal `} >{e.valueSpecification}</div>
                                                        </React.Fragment >)}
                                                </div>
                                                <div className='devider--horizontal'></div>
                                                <div className='general_offer-modal_main_info_description'>
                                                    <div className='value-text--bold'>Описание</div>
                                                    <div className='name-passive--8'>{element.equipmentDescription}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>)}
                                <img src={sliderNextIcon} className='general_offer-modal_slider_button right button'
                                    onClick={() => this.setState({ selectedSlide: 0, equipmentSliderIndex: this.state.equipmentSliderIndex === availableEquipment.length - 1 ? 0 : this.state.equipmentSliderIndex + 1 })} />
                            </div>
                            <div className='general_offer-modal_additional-wrapper'>
                                <div className='text-bold'>В стоимость входит</div>
                                <div className='general_offer-modal_additional_info'>
                                    <Slider width={270} height={92} gap={12} paginationOn={true} showInDesctop={true} showInMobile={true} parentId='offer-modal'>
                                        {[<div key={1} className='general_offer-modal_additional_info_item'>
                                            <img src={offerPersonIcon}></img>
                                            <div className='general_offer-modal_additional_info_item_wrapper'>
                                                <div className='text-bold'>Вызов мастера</div>
                                                <div className='name-passive--8'>Согласуем удобное время прихода мастера</div>
                                            </div>
                                        </div>,
                                        <div key={2} className='general_offer-modal_additional_info_item'>
                                            <img src={offerSetupIcon}></img>
                                            <div className='general_offer-modal_additional_info_item_wrapper'>
                                                <div className='text-bold'>Установка</div>
                                                <div className='name-passive--8'>Добавляем новые возможности и функции</div>
                                            </div>
                                        </div>,
                                        <div key={3} className='general_offer-modal_additional_info_item'>
                                            <img src={offerCustomIcon}></img>
                                            <div className='general_offer-modal_additional_info_item_wrapper'>
                                                <div className='text-bold'>Настройка</div>
                                                <div className='name-passive--8'>После установки настроим трубки и домофон</div>
                                            </div>
                                        </div>]}
                                    </Slider>

                                </div>
                                <div className='general_offer-modal_additional_button-wrapper'>
                                    <div className='general_offer-modal_additional_button button button-text'
                                        onClick={() => this.props.history.push((`${Navigation.AppealListPage}:tubeTaskTag`))}>Оставить заявку</div>
                                    <div className='name-passive--8'>Нажимая на кнопку, вы даёте согласие на обработку персональных данных</div>
                                </div>
                            </div>
                        </div>
                    </Modal>}
                <Popup isOpen={this.state.renewalCancelSuccess} onClose={() => this.setState({ renewalCancelSuccess: false })}>
                    <div className='info-popup'>
                        <div className='info-popup_wrapper'>
                            <div className='text-bold'>Вы отменили подписку</div>
                            <div className='name-passive--8'>Подписка отключится после окончания оплаченного периода {this.state.cancelledSubDateEnd !== null && moment(this.state.cancelledSubDateEnd).format("DD.MM.yyyy")}</div>
                        </div>
                        <div className='info-popup_button button button-text'
                            onClick={() => this.setState({ renewalCancelSuccess: false })}>Хорошо</div>
                    </div>
                </Popup>
                <Popup isOpen={this.state.renewalCancelError} onClose={() => this.setState({ renewalCancelError: false })}>
                    <div className='info-popup'>
                        <div className='info-popup_wrapper'>
                            <div className='text-bold'>Что то пошло не так</div>
                            <div className='name-passive--8'>Не удалось отключить автопродление, попробуйте позднее</div>
                        </div>
                        <div className='info-popup_button error button button-text'
                            onClick={() => this.setState({ renewalCancelError: false })}>Закрыть</div>
                    </div>
                </Popup>

                <div className='general'>
                    {/*account?.availableServices?.length >= 1 &&
                        <div style={{display:"flex", width:"100%",  justifyContent:"center", alignItems:"center"}}   onClick={() => this.props.history.push(`${Navigation.SubscriptionPage}`)}>
                           <MediaQuery minWidth={1920}>
                            <img src={BannerPro1920} alt="Пример" className='general_banner_ad'></img>
                          </MediaQuery>
                          <MediaQuery minWidth={1440} maxWidth={1919}>
                            <img src={BannerPro1440} alt="Пример" className='general_banner_ad'></img>
                          </MediaQuery>
                          <MediaQuery minWidth={1280} maxWidth={1439}>
                            <img src={BannerPro1280} alt="Пример" className='general_banner_ad'></img>
                          </MediaQuery>
                          <MediaQuery minWidth={1024} maxWidth={1279}>
                            <img src={BannerPro1024} alt="Пример" className='general_banner_ad'></img>
                          </MediaQuery>
                          <MediaQuery minWidth={960} maxWidth={1023}>
                            <img src={BannerPro960} alt="Пример" className='general_banner_ad'></img>
                          </MediaQuery>
                          <MediaQuery minWidth={768} maxWidth={959}>
                            <img src={BannerPro768} alt="Пример" className='general_banner_ad'></img>
                          </MediaQuery>
                          <MediaQuery minWidth={640} maxWidth={768}>
                            <img src={BannerPro640} alt="Пример" className='general_banner_ad'></img>
                          </MediaQuery>
                          <MediaQuery minWidth={480} maxWidth={639}>
                            <img src={BannerPro480} alt="Пример" className='general_banner_ad'></img>
                          </MediaQuery>
                          <MediaQuery minWidth={0} maxWidth={479}>
                            <img src={BannerPro320} alt="Пример" className='general_banner_ad'></img>
                          </MediaQuery>
                        </div>
                                                    */}
                    {account?.availableServices?.length >= 1 &&
                        <div className='general__accounts_ad'>
                            <div className='banner-title general__accounts_ad_title'>Полезная подписка, чтобы ничего не пропустить</div>
                            <div className='banner-text general__accounts_ad_sub-title'>Сохраните доступ к видеозвонкам, архиву записей и прямой трансляции видео</div>
                            <div className='general__accounts_ad_button button-text'
                                onClick={() => this.props.history.push(`${Navigation.SubscriptionPage}`)}>
                                Подробнее</div>
                        </div>
                    }
                    {/*account?.availableServices?.length >= 1 &&
                        <div className='general__accounts_ad'>
                            <div className='banner-title general__accounts_ad_title'>Скидки до 50%</div>
                            <div className='banner-text general__accounts_ad_sub-title'>при подключении тарифа PRO на 1 и 3 месяца. Срок акции: 07.03-10.03</div>
                            <div className='general__accounts_ad_button button-text'
                                onClick={() => this.props.history.push(`${Navigation.SubscriptionPage}`)}>
                                Подробнее</div>
                        </div>
                   */ }
                    <div className='general__panel'>
                        {account !== undefined && account?.processingServices !== undefined && account.processingServices.map((e, i) =>

                            <div className='general__panel_card_wrapper' key={i}>
                                <div className='general__panel_card' style={{ backgroundColor: "#eaf8ff" }}>
                                    <div className='text-bold' style={{ color: "#7d0a99" }}>Подписки</div>
                                    <DataString valueColor="#7d0a99" title="Наименование" value={e.serviceName} />
                                    {this.GetSubscriptionStatusCard(e)}
                                </div>
                            </div>)}

                        {account !== undefined && subscription !== undefined &&
                            <div className='general__panel_card_wrapper'>
                                <div className='general__panel_card' style={{ backgroundColor: "#eaf8ff" }}>
                                    <div className='text-bold' style={{ color: "#7d0a99" }}>Активные подписки</div>
                                    <DataString valueColor="#7d0a99" title="Наименование" value={subscription.serviceFullName || '---'} />
                                    <DataString title="Дата начала" value={`Подключена ${subscription.dateStart !== null ? moment(subscription.dateStart).format("DD.MM.yyyy") : "---"}`} />
                                    {subscription.dateEnd !== null &&
                                        <DataString title="Состояние" value={`Активна до ${moment(subscription.dateEnd).format("DD.MM.yyyy")}`} />
                                    }
                                    {subscription.dateRenewal !== null &&
                                        <DataString title="Автоматическое продление" value={`Произойдет  ${subscription.dateRenewal !== null ? moment(subscription.dateRenewal).format("DD.MM.yyyy") : "---"}`} />

                                    }
                                    <DataString title="Привязанная карта" value={`${subscription.cardFirst4 !== null ? subscription.cardFirst4 : '****'} **** **** ${subscription.cardLast4 !== null ? subscription.cardLast4 : '****'}`} />
                                    <div className='button button-text blue general__panel_card_subscribe_active press-bottom'
                                        onClick={() => this.setState({ renewalCancelIsOpen: true })}>Отменить подписку</div>
                                </div>
                            </div>
                        }

                        {account !== undefined &&
                            <div className='general__panel_card_wrapper'>
                                <div className='general__panel_card'>
                                    <div className='text-bold'>Мои услуги</div>
                                    <div className='general__panel_card_header'>
                                        <DataString title='Лицевой счет' value={account.balance.personalAccount} />
                                        <div className='general__panel_card_wrapper--column'>
                                            <div className='name-passive--8 '>Баланс</div>
                                            <div className={account.balance.balanceCurrent >= 0 ? "balance-text--green" : "balance-text--red"}>{account.balance.balanceCurrent} ₽</div>
                                        </div>
                                    </div>
                                    {account.services.length === 0 ?
                                        <>
                                            <div className='name-passive--8'>На данном лицевом счете нет услуг.</div>

                                        </>
                                        : <div className='general__panel_card_data'>
                                            {account.services.map((element, index) => {
                                                return <React.Fragment key={index}>
                                                    <div className='devider--horizontal'></div>
                                                    <DataString title='Наименование' value={element?.serviceFullName} />

                                                    <div className='general__panel_card_data_sub'>
                                                        <DataString title='Статус' value={element?.status} />
                                                        <DataString title='Тариф' value={element?.price + " ₽"} />
                                                    </div>

                                                </React.Fragment >
                                            })}

                                        </div>
                                    }





                                    <div className='devider--horizontal press-bottom'></div>
                                    {/*(account !== undefined && account?.accessMobileAppDomRu && account?.accessMobileAppDomRu?.password) &&
                                        <div>
                                            <div className='mp-text button nav__buttons_mp'
                                                onClick={() => {
                                                    this.setState({
                                                        appAccountIsOpen: true
                                                    })

                                                }}>
                                                <img src={appstoreIcon} />
                                                <div className=''>Мои учетные данные для Умный Дом.ру</div>
                                            </div>
                                        </div>
                                            */}

                                    <div className='general__panel_card_wrapper--row general__panel_card_footer'>
                                        <a className='general__panel_card_button button button-text very-big' href={`${Settings.PayCyfralServiceSite}Orders/${account.balance.personalAccount}`}>
                                            Оплатить
                                        </a>
                                        <div className='general__panel_card_wrapper--row general__panel_card_details'
                                            onClick={() =>
                                                this.props.history.push(`${Navigation.ServicesDetailsPage}/${this.props.accounts[this.props.selectedAccount].balance.personalAccountId}`)}>
                                            <div className='details-text'>
                                                Показать детали</div>
                                            <img src={detailsIcon}></img>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        {this.props.accounts.length === 0 &&
                            <div className='general__panel_card_wrapper'>
                                <div className='general__panel_card'>
                                    <div className='text-bold'>Мои услуги</div>
                                    <div className='name-passive--8 general__panel_card_no-appeal'>Добавьте лицевой счет, чтобы начать отслеживать свои услуги.</div>
                                    <div className='press-bottom'></div>
                                </div>
                            </div>}
                        {this.props.accounts.length === 0 &&
                            <div className='general__panel_card_wrapper'>
                                <div className='general__panel_card'>
                                    <div className='text-bold'>Мои заявки</div>
                                    <div className='name-passive--8 general__panel_card_no-appeal'>Добавьте лицевой счет, чтобы начать отслеживать свои заявки. </div>
                                    <div className='press-bottom'></div>
                                </div>
                            </div>}
                        {this.props.accounts.length !== 0 && activeAppeals.length === 0 && doneAppeals.length === 0 &&
                            <div className='general__panel_card_wrapper'>
                                <div className='general__panel_card'>
                                    <div className='text-bold'>Мои заявки</div>
                                    <div className='name-passive--8 general__panel_card_no-appeal'>У вас нет активных заявок. Вы можете создать обращение и отслеживать ее статус в разделе «Заявки»  </div>
                                    <div className='press-bottom'></div>
                                    {this.props.accounts.length !== 0 && <div className='general__panel_card_no-appeal_button blue-back button-text press-bottom'
                                        onClick={() =>
                                            this.props.history.push(`${Navigation.AppealListPage}:create`)}>Оставить заявку</div>}
                                    <div className='general__panel_card_no-appeal_button white-back button-text blue'
                                        onClick={() =>
                                            this.props.history.push(`${Navigation.AppealListPage}`)}>Перейти в раздел</div>
                                </div>
                            </div>}

                        {activeAppeals.length === 0 && doneAppeals.length !== 0 &&
                            <div className='general__panel_card_wrapper'>
                                <div className='general__panel_card'>
                                    <div className='text-bold'>Мои заявки</div>
                                    <div className='general__panel_card_data'>
                                        <DataString title='Номер заявки' value={doneAppeals[0].serialNumber} />
                                        <DataString title='Тема' value={doneAppeals[0].appealTopicName} />
                                        <DataString title='Раздел' value={doneAppeals[0].appealTagName} />
                                        <DataString title='Дата' value={moment(doneAppeals[0].dateCreate).format("DD.MM.yyyy")} />
                                        <DataString title='Статус' value={doneAppeals[0].taskTagStatusName} />
                                        {/*<DataString title='Оценить' >
                                                    <ScoreSelector
                                                        score_onClick={(index) => this.setState({ selectedScore: index })}
                                                        selectedScore={this.state.selectedScore} />
                                </DataString>*/}
                                    </div>
                                    <div className='devider--horizontal press-bottom'></div>
                                    <div className='general__panel_card_wrapper--row general__panel_card_details'
                                        onClick={() =>
                                            this.props.history.push(`${Navigation.AppealListPage}`)}>
                                        <div className='details-text'>
                                            Перейти к заявкам</div>
                                        <img src={detailsIcon}></img>
                                    </div>
                                </div>
                            </div>}
                        {activeAppeals.length !== 0 &&
                            <div className='general__panel_card_wrapper'>
                                <div className='general__panel_card'>
                                    <div className='text-bold'>Мои заявки</div>
                                    <div className='general__panel_card_data'>
                                        <DataString title='Номер заявки' value={activeAppeals[0].serialNumber} />
                                        <DataString title='Тема' value={activeAppeals[0].appealTopicName} />
                                        <DataString title='Раздел' value={activeAppeals[0].appealTagName} />
                                        <DataString title='Дата' value={moment(activeAppeals[0].dateCreate).format("DD.MM.yyyy")} />
                                        <DataString title='Статус' value={activeAppeals[0].taskTagStatusName} />
                                    </div>
                                    <div className='devider--horizontal press-bottom'></div>
                                    <div className='general__panel_card_wrapper--row general__panel_card_details'
                                        onClick={() =>
                                            this.props.history.push(`${Navigation.AppealListPage}`)}>
                                        <div className='details-text'>
                                            Перейти к заявкам</div>
                                        <img src={detailsIcon}></img>
                                    </div>
                                </div>
                            </div>}
                        {this.props.equipmentIsLoading && availableEquipment.length !== 0 &&
                            <div className='general__panel_card_wrapper'>
                                <div className='general_offer'>
                                    <div className='general_offer_info'>
                                        <div className='text-bold'>Заказывайте оборудование не выходя из дома</div>
                                        <div className='name-passive--8'>Настроим и проверим оборудование после установки</div>
                                        <div className='text-bold--mobile'>Заказывайте оборудование не выходя из дома</div>
                                        <div className='name-passive--8'>Менеджер свяжется с вами для уточнения деталей заказа и согласует время прихода специалиста по установке</div>
                                        <div className='general_offer_info_button button button-text'
                                            onClick={() => this.setState({ offerIsOpen: true })}>Подробнее</div>
                                    </div>
                                    <div className='general_offer_images'>
                                        <img src={offerTubeImage}></img>
                                        <img src={offerMonitorImage}></img>
                                    </div>
                                </div>
                            </div>}
                        {/*<div className='general__panel_card_wrapper' >
                                    <div className='general__panel_card'>
                                        <div className='text-bold'>Подписки</div>
                                        <DataString title="Наименование" value={testSub.serviceName} />
                                        {this.GetSubscriptionStatusCard(testSub)}
                                    </div>
                                                </div>*/}



                    </div>
                </div>

            </>
        );

    }
};

export default connect(
    (state: ApplicationState) => ({ ...state.AccountState, ...state.guide }),
    AccountStore.actionCreators
)(GeneralPage as any);
